import PropTypes from "prop-types";
import React from "react";
import Swiper, { SwiperSlide } from "../../components/swiper";
import testimonialData from "../../data/testimonial/testimonial-one.json";
import TestimonialOneSingle from "../../components/testimonial/TestimonialOneSingle.js";

const TestimonialOne = ({
  block,
  backgroundImage,
  testimonialClass
}) => {
  // swiper slider settings
  const settings = {
    options: {
      slidesPerView: 1,
      loop: true,
      navigation: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false
      }
    }
  };

  return (
    <div
      className={`testimonial-area ${block.spaceTopClass ? block.spaceTopClass : ""}  ${
        block.spaceBottomClass ? block.spaceBottomClass : ""
      } ${block.spaceLeftClass ? block.spaceLeftClass : ""}  ${
        block.spaceRightClass ? block.spaceRightClass : ""
      } ${block.bgColorClass ? block.bgColorClass : ""}`}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-10 ml-auto mr-auto">
            <div className="testimonial-active nav-style-1 nav-testi-style">
              <Swiper {...settings}>
                {block?.componentData?.map((single, key) => {
                    return (
                      <SwiperSlide key={key}>
                      <TestimonialOneSingle
                        data={single}
                        key={key}
                        sliderClass="swiper-slide"
                        testimonialClass={testimonialClass}
                      />
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TestimonialOne.propTypes = {
  bgColorClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  testimonialClass: PropTypes.string
};

export default TestimonialOne;
